import { LicensedPartners as LicensedPartnersContent } from 'LicensedPartners';

const LicensedPartersBySport = () => {
  return <LicensedPartnersContent />;
};

export default LicensedPartersBySport;
